var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 12H21","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M3 6H21","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M3 18H21","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

MenuInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
